import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFile = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	viewBox: "0 0 56 56",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M36.985 0H7.963C7.155 0 6.5.655 6.5 1.926V55c0 .345.655 1 1.463 1h40.074c.808 0 1.463-.655 1.463-1V12.978c0-.696-.093-.92-.257-1.085L37.607.257A.884.884 0 0 0 36.985 0z",
			style: { fill: "#e9e9e0" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.5.151V12h11.849z",
			style: { fill: "#d9d7ca" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.5 42h2v14h-2zM30.5 23v-2h-2v-2h-2v2h-2v2h2v2h-2v2h2v2h-2v2h2v3h2v-3h2v-2h-2v-2h2v-2h-2v-2z",
			style: { fill: "#c8bdb8" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.5 34h8v8h-8z",
			style: { fill: "#cbb292" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.5 43h-10V33h10v10zm-8-2h6v-6h-6v6z",
			style: { fill: "#5e5f62" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.5 36h8v2h-8z",
			style: { fill: "#5e5f62" }
		})
	]
});
export default SvgFile;
